import { useEffect, useRef, useState } from "react";
import { mountWords } from "./utils/words";
import { isBorrowedTailFinish, validateWords } from "./utils/wordsComparison";
import delay from "./utils/delay";

const useChapter = ({
  transcription,
  phrasesToRead,
  triggers,
  setChapterComplete,
  setChapterStart,
  showModal = false,
  testMode,
  onSubmit,
  setIsTransitioning,
  triggerDelay = 4000,
}) => {
  const [words, setWords] = useState("");
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);

  const hasInitChapter = useRef(false);

  // console.log(">>> words", words)

  const fireTriggers = async (toTrigger) => {
    if(toTrigger && toTrigger.length) {
      for(const trigger of toTrigger) {
        triggers[trigger]()
        if (triggerDelay > 0) await delay(triggerDelay); 
      }
    }
  }

  const handlePhraseComplete = async () => {
    const nextPhraseIndex = currentPhraseIndex + 1;
    const toTrigger = phrasesToRead[currentPhraseIndex].triggers
    const nextPhrase = phrasesToRead[nextPhraseIndex];
    // console.log('>>> nextPhrase', nextPhrase)
    if(!nextPhrase) {
      setChapterComplete(true);
      await fireTriggers(toTrigger)
      // handle next chapter:
      // mute mic
      // reset transcription
      // reset words
      setWords("");
      if(testMode) {
        onSubmit && onSubmit()
      }
      return
    }

    const mountedWords = mountWords(nextPhrase.name, nextPhrase.text)
    setCurrentPhraseIndex(nextPhraseIndex);
    setWords(mountedWords);

    await fireTriggers(toTrigger)
  }

  const testModeTrigger = () => {
    if(testMode) handlePhraseComplete();
  }

  const initChapter = () => {
    hasInitChapter.current = true;
    const mountedWords = mountWords(phrasesToRead[0].name, phrasesToRead[0].text)
    setCurrentPhraseIndex(0);
    setWords(mountedWords);
    setChapterStart(true);
  }

  useEffect(() => {
    setIsTransitioning?.(false);
    if(!showModal) {
      initChapter();
    }
  }, [])

  useEffect(() => {
    if(!hasInitChapter.current && !showModal) {
      initChapter();
    }
  }, [showModal])

  useEffect(() => {
    if(words && words.length > 0) {
      const { validatedWords, hasNewValidWords } = validateWords(words, transcription);
      const areAllWordsValid = validatedWords.every(word => word.isValid);
      const previousSpoken = phrasesToRead[currentPhraseIndex - 1]?.text;
      if (areAllWordsValid && isBorrowedTailFinish(words, transcription, previousSpoken)) {
        return;
      }
      if(areAllWordsValid) {
        handlePhraseComplete();
        return;
      }
      setWords(validatedWords);
    }
  }, [transcription])
  
  return {
    testModeTrigger,
  }
}

export default useChapter;